/*
 * Taken from:
 * https://github.com/netlify/netlify-react-ui/tree/1bc4a79afcd5f45785354028b5280c94ea6802b3/apps/netlify-react-ui/src/components/ui/ListLoader.tsx
 */

import { cn } from "@netlify/ui";
import CardsMask from "./assets/loader-mask-cards.svg?react";
import DefaultMask from "./assets/loader-mask-list.svg?react";
import SitesMask from "./assets/loader-mask-sites.svg?react";

const MASKS = {
  cards: CardsMask,
  default: DefaultMask,
  sites: SitesMask,
};

const animatedBackgroundStyles = (loading: boolean, type: keyof typeof MASKS) =>
  cn(
    "tw-relative",
    "tw-overflow-hidden",
    "tw-max-w-list-loader",
    type === "sites" ? "tw-h-[200px]" : "tw-h-42",
    "tw-rounded-sm",
    loading &&
      cn(
        "tw-bg-list-loader-static",
        "motion-safe:tw-bg-list-loader-animated",
        "motion-safe:tw-animate-list-loader-animated-background",
      ),
    !loading && `tw-bg-gray-lighter dark:tw-bg-gray-darkest`,
  );

const listLoaderWrapperStyles = (type: keyof typeof MASKS) =>
  cn(
    "tw-overflow-hidden",
    type === "sites" ? "tw-h-[200px] tw-max-h-[200px]" : "tw-h-42 tw-max-h-42",
    "tw-relative",
    "after:tw-content-empty",
    "after:tw-h-66",
    "after:tw-inset-x-0",
    "after:tw-absolute",
    "after:tw-pointer-events-none",
    "after:tw-bottom-0",
    "after:tw-z-10",
  );

export type ListLoaderProps = {
  className?: string | undefined;
  faded?: boolean | undefined;
  fullWidth?: boolean | undefined;
  hero?: boolean | undefined;
  loading?: boolean | undefined;
  maskClassName?: string | undefined;
  outset?: string | undefined;
  settings?: boolean | undefined;
  type?: keyof typeof MASKS | undefined;
};

// TODO(ndhoule): Lots of these props are not applicable/very specific to the Netlify app this
// component is taken from (e.g. `settings`). Refactor this component to be more generic/remove some
// of the props.
// TODO(ndhoule): Wrap this and expose it via `src/components/ListLoader`
/**
 * @internal
 */
export const ListLoader = ({
  className,
  faded = false,
  fullWidth = false,
  hero = false,
  loading = true,
  maskClassName,
  outset,
  settings = false,
  type = "default",
}: ListLoaderProps = {}) => {
  const Mask = MASKS[type];

  const maskClassNames = cn([
    "tw-absolute",
    "tw-max-w-none",
    "tw-text-white",
    "dark:tw-text-black",
    maskClassName,
  ]);
  return (
    <div
      className={cn(
        listLoaderWrapperStyles(type),
        fullWidth && `tw-w-full`,
        hero && `tw-h-list-loader-card-settings tw-max-w-1/3`,
        settings && `tw-h-list-loader-card-settings tw-max-w-full`,
        (!loading || faded) && `after:tw-bg-faded`,
        outset,
        className,
      )}
    >
      <div className={cn(animatedBackgroundStyles(loading, type))}>
        <span className="tw-sr-only">Loading</span>
        <Mask className={maskClassNames} />
      </div>
    </div>
  );
};
